import React from 'react';
import { Stats } from '../../../types';
import { Users, TrendingUp, CheckCircle, Clock } from 'lucide-react';
import { motion } from 'motion/react';

interface DashboardProps {
  stats: Stats | null;
}

export const Dashboard: React.FC<DashboardProps> = ({ stats }) => {
  if (!stats) return null;

  const cards = [
    { label: 'Gesamt Projekte', value: stats.total, icon: Users, color: 'text-blue-600', bg: 'bg-blue-50' },
    { label: 'Neue Projekte', value: stats.new, icon: Clock, color: 'text-amber-600', bg: 'bg-amber-50' },
    { label: 'Abgeschlossen', value: stats.won, icon: CheckCircle, color: 'text-emerald-600', bg: 'bg-emerald-50' },
    { label: 'Conversion Rate', value: `${stats.conversionRate}%`, icon: TrendingUp, color: 'text-indigo-600', bg: 'bg-indigo-50' },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {cards.map((card, idx) => (
        <motion.div 
          key={card.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: idx * 0.1 }}
          className="card p-6 flex items-start justify-between"
        >
          <div>
            <p className="text-sm font-medium text-app-text-subtle mb-1">{card.label}</p>
            <h3 className="text-2xl font-bold text-app-text">{card.value}</h3>
          </div>
          <div className={`p-3 rounded-xl ${card.bg}`}>
            <card.icon className={`w-6 h-6 ${card.color}`} />
          </div>
        </motion.div>
      ))}
    </div>
  );
};

